import { render, staticRenderFns } from "./OFormGroup.vue?vue&type=template&id=93479f00&scoped=true&"
import script from "./OFormGroup.vue?vue&type=script&lang=js&"
export * from "./OFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./OFormGroup.vue?vue&type=style&index=0&id=93479f00&prod&scoped=true&lang=css&"
import style1 from "./OFormGroup.vue?vue&type=style&index=1&id=93479f00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93479f00",
  null
  
)

export default component.exports